import {
  ContentFeed,
  ContentFeedSearchResult,
  InputContentFeedSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";

import providers from "@/lib/api";

const getFeedIdsToUpdate = (authorId: string, feeds: ContentFeed[], purchasedFeedId?: string) => {
  if (typeof purchasedFeedId === "string") return [purchasedFeedId];

  return feeds.reduce<string[]>((acc, feed) => {
    if (!feed.purchased && feed.userId === authorId) {
      acc.push(feed.id);
    }
    return acc;
  }, []);
};

const getUpdatedList = (currentList: ContentFeedSearchResult, updatedItems: ContentFeed[]) => {
  let newList = currentList.result.map(i => {
    const index = updatedItems.findIndex(item => item.id === i.id);
    let item = i;
    if (index > -1) {
      item = updatedItems.splice(index, 1)[0];
    }
    return item;
  });
  if (updatedItems.length > 0) {
    if (currentList.hasNextPage) {
      newList.splice(newList.length - updatedItems.length, updatedItems.length);
    }
    newList = updatedItems.concat(newList);
  }
  return newList;
};

export const getPurchasedContentFeeds = async (
  { authorId, purchasedFeedId }: { authorId: string; purchasedFeedId?: string },
  contentFeedSearchResult: ContentFeedSearchResult,
  requestData?: Partial<InputContentFeedSearch>,
  requestString?: string
): Promise<ContentFeed[]> => {
  const feedIds = getFeedIdsToUpdate(authorId, contentFeedSearchResult.result, purchasedFeedId);
  if (feedIds.length === 0) return contentFeedSearchResult.result;
  const response = await providers.ContentFeedProvider.search(
    {
      data: {
        userId: authorId,
        ids: feedIds,
        size: feedIds.length,
        includeScheduled: false,
        published: true,
        ...requestData,
      },
    },
    requestString
  );
  return getUpdatedList(contentFeedSearchResult, response.result);
};
